<div class="row">
    <div class="col-sm-12">
        <core-card [actions]="['collapse']">
            <h4 class="card-title">{{'StartProjectDetail' | translate}}</h4>
            <div class="card-body">
                <div class="table-responsive">
                    <table id="informationTable" class="table table-sm table-hover">
                        <tr>
                            <th class="text-center" colspan="1">{{'AssignedEmployee' | translate}}</th>
                            <td class="text-center" colspan="1">{{startProjectResult.assignedEmployeeFullName}}</td>
                            <th class="text-center" colspan="1">{{'Project' | translate}}</th>
                            <td class="text-center" colspan="1">{{startProjectResult.projectName}}</td>
                        </tr>
                    </table>
                </div>
                <form class="form">
                    <div class="row">
                        <div class="col-12">
                            <!-- <button type="submit" rippleeffect=""
                                class="btn btn-sm btn-primary mr-1 waves-effect waves-float waves-light"
                                (click)="loadData()">{{'Search' | translate}}</button> -->
                            <button type="button"
                                *ngIf="addStartProjectDetailButton === true && startProjectResult.isDone === false"
                                class="btn btn-sm btn-outline-success" (click)="addData()" rippleEffect>
                                {{'Add' | translate}}
                            </button>
                        </div>
                    </div>
                </form>
                <div class="table-responsive">
                    <table class="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th class="text-center">{{'Title' | translate}}</th>
                                <th class="text-center">{{'AssignedEmployee' | translate}}</th>
                                <th class="text-center">{{'Status' | translate}}</th>
                                <th class="text-center">{{'Actions' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of startProjectDetailResultList.data">
                                <td class="text-center">{{item.title}}</td>
                                <td class="text-center">{{item.assignedEmployeeFullName}}</td>
                                <td class="text-center">{{projectStatus[item.projectStatus] | translate}}</td>
                                <td class="text-center">
                                    <button type="button" tooltipClass="fadeInAnimation" placement="top"
                                        ngbTooltip="{{'Detail' | translate}}"
                                        (click)="showData(item)"><i data-feather="box"></i></button>
                                    <button [disabled]="isBusy === true" type="button" tooltipClass="fadeInAnimation"
                                        placement="top" ngbTooltip="{{'History' | translate}}"
                                        (click)="demonstrateHistory(historyModal, item.id)"><i
                                            class="fa fa-history"></i></button>
                                    <button [disabled]="isBusy === true" *ngIf="deleteStartProjectDetailButton === true"
                                        type="button" tooltipClass="fadeInAnimation" placement="top"
                                        ngbTooltip="{{'Delete' | translate}}"
                                        (click)="openAlertModal(modalDanger, item.id)"><i
                                            data-feather="trash"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </core-card>
    </div>
</div>
<ng-template #modalDanger let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'Alert' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        {{utility.AlertModalDeleteMessage | translate}}
    </div>
    <div class="modal-footer">
        <button type="submit" rippleeffect="" [disabled]="isBusy === true"
            class="btn btn-danger mr-1 waves-effect waves-float waves-light" (click)="delete()">{{'Delete' |
            translate}}</button>
    </div>
</ng-template>
<core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="start-project-detail"
    overlayClass="modal-backdrop">
    <app-start-project-detail *ngIf="startProjectDetail !== null" [startProjectDetail]="startProjectDetail!"
        [employeeDropdown]="employeeDropdown" (reloadData)="loadData()"></app-start-project-detail>
</core-sidebar>
<ng-template #historyModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'History' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-project-history [mode]="'Detail'" [id]="startProjectIdForHistory"></app-project-history>
    </div>
</ng-template>
<app-alert [result]="result"></app-alert>